module.exports = __webpack_public_path__ + "static/media/Lilligant_gaussian2.e58488e6.png";